import { chipClasses } from "@mui/material";
const MuiChip = {
    defaultProps: {
        variant: 'filled',
        size: 'small'
    },
    styleOverrides: {
        root: {
            borderRadius: '4px'
        },
        sizeSmall: {
            height: '20px'
        },
        deleteIcon: ({ theme })=>({
                padding: '2px',
                color: theme.palette.text.secondary
            }),
        icon: ({ theme })=>({
                color: theme.palette.text.primary,
                width: '12px',
                height: '12px'
            }),
        iconSmall: ({ theme })=>({
                marginLeft: theme.spacing(1)
            }),
        labelSmall: {
            fontSize: '12px'
        },
        filled: ({ theme })=>({
                backgroundColor: theme.palette.status.default.lowContrast,
                border: `1px solid ${theme.palette.status.default.lowContrast}`,
                color: theme.palette.text.primary,
                [`& .${chipClasses.icon}`]: {
                    color: theme.palette.text.primary
                }
            }),
        outlined: ({ theme })=>({
                backgroundColor: theme.palette.background.container,
                border: `1px solid ${theme.palette.border.subtle}`,
                color: theme.palette.text.secondary,
                '&:hover, &:focus': {
                    backgroundColor: theme.palette.background.hover
                },
                [`& .${chipClasses.icon}`]: {
                    color: theme.palette.text.secondary
                }
            })
    }
};
export { MuiChip };

//# sourceMappingURL=chip-overrides.js.map